import { ButtonWithLinkStyle, Typography } from '@capsule/consumer-design-system';

import { useFormikContext } from 'formik';
import { css } from 'styled-components';

import { openChat } from 'src/app/state/slices/chat';
import { useDispatch } from 'src/app/state/store';

export const UndeliverableAddressError = () => {
  const dispatch = useDispatch();
  const chat = () => dispatch(openChat());

  const { status } = useFormikContext();

  const hasIncompleteZip = status?.isZipCodeDeliverable === undefined || status?.isZipCodeDeliverable === null;
  const isDeliverable = status?.isZipCodeDeliverable === true;
  const isLoading = !status || status?.isSubmitting === true;

  if (isDeliverable || hasIncompleteZip || isLoading) return null;

  return (
    <Typography
      data-cy="zipCodeErrorBlock"
      css={css`
        margin: ${({ theme }) => theme.space.s4} 0;
        padding: ${({ theme }) => theme.space.s3};
        border: 1px solid;
        border-color: ${({ theme }) => theme.colors.capsuleRed60};
        border-radius: ${({ theme }) => theme.radii.r100};
        color: ${({ theme }) => theme.colors.capsuleRed60};
      `}
      role="alert"
    >
      This address is outside of our current delivery area. You can also chat with us{' '}
      <ButtonWithLinkStyle
        onClick={chat}
        css={css`
          display: inline-block;
        `}
      >
        here
      </ButtonWithLinkStyle>{' '}
      and we can help.
    </Typography>
  );
};
